import React from 'react';

export const EvbSection = () => {
  return (
    <section id="evb" className="py-[140px] px-10 sm:px-20 bg-white relative">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid lg:grid-cols-2 gap-[140px] items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-[62px] font-[900] leading-[1.1] tracking-[-0.03em] mb-8 text-[#0D0D0D]">
              <span className="bg-gradient-to-r from-[#006B3F] to-[#7CB342] bg-clip-text text-transparent">
                eVB-Nummer
              </span>
              <br />
              für Ihre Kfz-Zulassung
            </h2>
            <p className="text-[19px] leading-[1.75] text-[#5A5A5A] mb-12 max-w-[560px]">
              Als HDI Hauptvertretung Mazlum Aksu bieten wir Ihnen persönliche Beratung 
              und schnelle Bearbeitung Ihrer eVB-Anfrage für den Kreis Mettmann und Velbert. 
              Sofort, zuverlässig und professionell.
            </p>
          </div>

          {/* Right - Features */}
          <div className="flex flex-col gap-5">
            <div className="flex items-center gap-5 px-6 py-6 bg-gradient-to-br from-[#FAFBFC] to-white border border-[#006B3F]/[0.08] rounded-2xl transition-all duration-300 hover:bg-white hover:border-[#006B3F]/[0.16] hover:translate-x-2">
              <div className="w-14 h-14 bg-gradient-to-br from-[#006B3F]/[0.08] to-[#7CB342]/[0.08] rounded-[14px] flex items-center justify-center text-[26px] flex-shrink-0">
                ⚡
              </div>
              <div>
                <h4 className="text-[17px] font-bold text-[#0D0D0D] mb-1 tracking-tight">
                  eVB-Nummer sofort erhalten
                </h4>
                <p className="text-[14px] text-[#5A5A5A]">
                  Binnen weniger Minuten per WhatsApp
                </p>
              </div>
            </div>

            <div className="flex items-center gap-5 px-6 py-6 bg-gradient-to-br from-[#FAFBFC] to-white border border-[#006B3F]/[0.08] rounded-2xl transition-all duration-300 hover:bg-white hover:border-[#006B3F]/[0.16] hover:translate-x-2">
              <div className="w-14 h-14 bg-gradient-to-br from-[#006B3F]/[0.08] to-[#7CB342]/[0.08] rounded-[14px] flex items-center justify-center text-[26px] flex-shrink-0">
                🏆
              </div>
              <div>
                <h4 className="text-[17px] font-bold text-[#0D0D0D] mb-1 tracking-tight">
                  HDI Hauptvertretung Mazlum Aksu
                </h4>
                <p className="text-[14px] text-[#5A5A5A]">
                  Persönliche Beratung vor Ort, telefonisch, per E-Mail oder WhatsApp.
                </p>
              </div>
            </div>

            <div className="flex items-center gap-5 px-6 py-6 bg-gradient-to-br from-[#FAFBFC] to-white border border-[#006B3F]/[0.08] rounded-2xl transition-all duration-300 hover:bg-white hover:border-[#006B3F]/[0.16] hover:translate-x-2">
              <div className="w-14 h-14 bg-gradient-to-br from-[#006B3F]/[0.08] to-[#7CB342]/[0.08] rounded-[14px] flex items-center justify-center text-[26px] flex-shrink-0">
                📱
              </div>
              <div>
                <h4 className="text-[17px] font-bold text-[#0D0D0D] mb-1 tracking-tight">
                  WhatsApp: 01515 9182828
                </h4>
                <p className="text-[14px] text-[#5A5A5A]">
                  Direkter Kontakt für Ihre eVB-Anfrage
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};